/*
 * Runtime configuration.
 *
 * Each value can be overridden at BUILD time by a REACT_APP_* environment
 * variable (set them in the Vercel project settings). When a variable is not
 * set, the hardcoded fallback below is used, so behaviour is unchanged from
 * before this indirection was added.
 *
 * Why: the Mapbox token and Google Maps key were hardcoded, so rotating either
 * one required a code change and a redeploy. Create React App inlines
 * process.env.REACT_APP_* at build time, so setting the variable in Vercel and
 * redeploying is now enough.
 *
 * NOTE: these values ship to the browser. That is inherent to a client-side
 * map and is not something an env var hides — the protection is provider-side
 * URL restrictions on the key itself.
 */

/*
 * `process.env.REACT_APP_X` must be written out literally, exactly like this.
 *
 * Webpack's DefinePlugin performs a TEXTUAL substitution of the string
 * "process.env" and nothing else. A bare `process` is never defined in a
 * browser, so an apparently-safer guard such as
 *
 *     const env = typeof process !== "undefined" && process.env ? process.env : {};
 *
 * compiles to `typeof process !== "undefined" && {…inlined…} ? {…} : {}`, which
 * evaluates to `{}` at runtime — silently discarding every variable and falling
 * back to the hardcoded defaults below. That exact bug shipped and made the app
 * keep calling a stale API host no matter what was configured in Vercel.
 *
 * Do not "harden" these lines. Verify a change by checking the compiled output
 * reads `{…}.REACT_APP_X`, not merely that the value appears somewhere in the
 * bundle — DefinePlugin inlines the whole env object regardless of whether any
 * code path uses it.
 */
/* eslint-disable no-undef */
export const config = {
	apiBaseUrl: process.env.REACT_APP_LOGISTIC_BASE_URL || "https://logistic-api.vercel.app/api",
	uploadUrl:
		process.env.REACT_APP_UPLOAD_URL || "https://j09bqsgnmnwtv8kt.public.blob.vercel-storage.com",
	googleMapApiKey:
		process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyDzTh6-lxvbUVqr2c_vXDDFVcYoa0K-Rj4",
	accessTokenName: "elg:accessToken",
	company: {
		name: "Efficiency Logistics Group",
		website: "http://www.efficiencyfreight.com/",
		contact: "sales@efficiencyfreight.com",
		invoiceEmail: "invoices@efficiencyfreight.com",
		noaEmail: "noa@efficiencyfreight.com",
		accountingEmail: "accounting@efficiencyfreight.com",
	},
	appType: "elg",
	/*
	 * OSRM routing/matrix host, replacing the Mapbox Directions and
	 * Directions Matrix APIs. Keyless.
	 *
	 * The default is the public OSRM demo server, which the project states is
	 * NOT intended for production use and applies rate limiting. It is fine for
	 * a demo or low volume, but for real dispatch traffic point this at your own
	 * OSRM instance (or a hosted provider) via REACT_APP_OSRM_URL — no code
	 * change needed, the API is identical.
	 */
	osrmBaseUrl: process.env.REACT_APP_OSRM_URL || "https://router.project-osrm.org",
	/*
	 * MAPBOX_TOKEN and sessionToken were removed. The app no longer calls any
	 * Mapbox service: tiles come from OpenFreeMap/CARTO via MapLibre, geocoding
	 * from Photon, and routing/matrix from OSRM — all keyless. The token that
	 * lived here was revoked and belonged to a third-party account, and
	 * sessionToken was only referenced from commented-out code.
	 */
};
